import { createAction, props } from '@ngrx/store';
import { ICategoryData } from 'src/app/shared/types/category';

const categoryIsCreated = 'CATEGORY_IS_CREATED';
const removeRecentCategory = 'REMOVE_RECENT_CATEGORY';
export const categoryIsCreatedAction = createAction(
  categoryIsCreated,
  props<{ newCategory: ICategoryData }>()
);

export const removeRecentCategoryAction = createAction(removeRecentCategory);
